import React from 'react';

export interface Session {
  user: {
    name: string;
    email: string;
    image: string;
  };
  accountType?: string;
  emailVerified?: boolean;
  firebaseId?: string;
  dayliteId?: string;
}

export interface SessionContextProps {
  session: Session | null;
  setSession: React.Dispatch<React.SetStateAction<Session | null>>;
  loading: boolean;
}

const SessionContext = React.createContext<SessionContextProps>({
  session: null,
  setSession: () => {},
  loading: true
});

export default SessionContext;

export const useSession = () => React.useContext(SessionContext);
